import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import Main from '../BrowserSupport/Main';
import CenteredLogo from '../components/CenteredLogo';
import BrandLoader from '../components/BrandLoader';
import WithBackgroundImage from '../components/WithBackgroundImage';
import { currentUserStore } from '../CurrentUserStore';
import LoginButton from '../Login/LoginButton';
import Title from '../Title';
import { T } from '../Translations';

const LoggedOut: React.FC = () => {
  switch (currentUserStore.currentUserState.kind) {
    case 'anonymous':
    case 'unauthorized':
    case 'errored':
      return (
        <WithBackgroundImage>
          <Main>
            <div
              className={clsx(
                'mx-auto w-92.5 items-center justify-center',
                'rounded-md bg-white px-6 pt-8 shadow lg:w-96',
              )}
            >
              <div className={clsx('place-items-center p-2')}>
                <Title title="Logged Out" />
                <CenteredLogo />
                <h1
                  className={clsx('text-slate-dark my-10 text-xl font-medium')}
                  data-test-title={true}
                >
                  <T kind="You have been logged out" />
                </h1>
                <p>
                  <T kind="If you would like to log in again, click the button below." />
                </p>
                <div className="my-8">
                  <LoginButton />
                </div>
              </div>
            </div>
          </Main>
        </WithBackgroundImage>
      );
    case 'waiting':
    case 'identifying':
    case 'logging-out':
      return <BrandLoader />;
    case 'identified':
      return <Navigate to="/" />;
  }
};

export default observer(LoggedOut);
